module.exports = __webpack_public_path__ + "./fonts/AvantGarde-Medium.ttf";